var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandedAll(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.444 16.244c.154.17.355.256.556.256a.745.745 0 00.556-.256l4.714-5.25a.947.947 0 000-1.237.73.73 0 00-1.11 0L10 14.39 5.84 9.756a.73.73 0 00-1.11 0 .947.947 0 000 1.238l4.713 5.25zm0-5c.154.17.355.256.556.256a.745.745 0 00.556-.255l4.714-5.25a.946.946 0 000-1.238.73.73 0 00-1.11 0L10 9.39 5.84 4.756a.73.73 0 00-1.11 0 .946.946 0 000 1.238l4.713 5.25z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandedAll);
export default ForwardRef;